import { render, staticRenderFns } from "./SDKList.vue?vue&type=template&id=4dceced2&scoped=true"
import script from "./SDKList.vue?vue&type=script&lang=js"
export * from "./SDKList.vue?vue&type=script&lang=js"
import style0 from "./SDKList.vue?vue&type=style&index=0&id=4dceced2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dceced2",
  null
  
)

export default component.exports